import React, { useEffect } from "react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import Sidenav from "Common/Components/examples/Sidenav";
import theme from "Common/hooks/assets/theme";
import { useSoftUIController } from "Common/hooks/context";
import brand from "Common/hooks/assets/images/lmsLogo1.png";
import Login from "Common/Auth/SignIn";
import DashboardLayout from "Common/Components/examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "Common/Components/examples/Navbars/DashboardNavbar";
import { showSidebar } from "Common/Client/routeUtils";
import Register from "Common/Auth/SignUp";
import routes from "./ExpertRoutes";
import ExpertLandingPage from "../Components/Dashboard/ExpertLandingPage";
import ExpertProfile from "../Components/Profile/ExpertProfile";
import ExpertSkills from "../Components/Skills/Skills";
import PurchasedExpertServicesPage from "PlatForms/SelfLMS/Components/ExpertService/PurchasedExpertServices";
import ExpertServiceManagement from "../Components/PurchasedServices/ExpertServiceManagment";


function ExpertContent() {
  const [controller] = useSoftUIController();
  const { layout, sidenavColor } = controller;
  const location = useLocation();

  useEffect(() => {
    sessionStorage.setItem("currentPath", location.pathname);
    console.log(" Current expert Route:", location.pathname);
  }, [location.pathname]);


  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
  {layout === "dashboard" && showSidebar && (
          <>
            <Sidenav
              color={sidenavColor}
              brand={brand}
              brandName="Expert"
              routes={routes}
            />
          </>
        )}
        <DashboardLayout>
          <DashboardNavbar />
               

        <Routes>
          {/* Dashboard Route */}
          <Route path="/" element={<ExpertLandingPage />} />

          
          <Route path="/expert-profile" element={< ExpertProfile />} />
          <Route path="/expert-skills" element={< ExpertSkills />} />
          <Route path="/expert-services" element={< ExpertServiceManagement />} />


    

          {/* Auth Routes */}
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />

          {/* Catch-all */}
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </DashboardLayout>
    </ThemeProvider>
  );
}

export default ExpertContent;
